var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('embed',{attrs:{"src":"/static/pdf/Department_of_Education_Translation_Form_Kindergarten.pdf","type":"application/pdf","width":"100%","height":"1400px"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-000bcd00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/templates/pdfKind.html
// module id = null
// module chunks = 